<app-page-header title="Home" active_item="Depósito" titleLink="/reports"  ></app-page-header>
<div class="loading-deposit" *ngIf="!isLoaded">
  <div class="dimmer active">
    <div class="lds-ring">
      <div></div>
    </div>
  </div>
</div>
<h5>{{ 'common.pixDeposit' | translate }}</h5>
<div class="row">
  <div class="col-12">
    <div class="card sales-summary rounded-10 shadow">
      <div class="card-header">
        <div class="card-title mb-0">{{ 'common.paymentData' | translate}}</div>
      </div>
      <div class="card-body">
        <form [formGroup]="deposito">
          <div class="row">
            <div class="col-xl-3 col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="txtDocumentoFavorecido" class="form-label">{{ 'common.payerDocument' | translate}} <span class="text-danger">*</span></label>
                <input mask="CPF_CNPJ" [formControl]="deposito.controls.documento" class="form-control" [ngClass]="{'is-invalid state-invalid': deposito.controls.documento.invalid && isSubmitted}" type="text" name="documentoFavorecido" id="txtDocumentoFavorecido">
                <div class="invalid-feedback">{{documentFeedBack}}</div>
              </div>
            </div>
            <div class="col-xl-9 col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="txtNomeFavorecido" class="form-label">{{ 'common.payerName' | translate}} <span class="text-danger">*</span></label>
                <input class="form-control" [ngClass]="{'is-invalid state-invalid': deposito.controls.nome.invalid && isSubmitted}" [formControl]="deposito.controls.nome" type="text" name="nomeFavorecido" id="txtNomeFavorecido" [required]="true">
                <div class="invalid-feedback">{{nomeFeedBack}}</div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="txtValorSolicitado" class="form-label">{{ 'common.value' | translate}} <span class="text-danger">*</span></label>
                <input placeholder="{{ 0 | formatCurrency }}" [formControl]="deposito.controls.valor" currencyMask [options]="{ prefix: ('' | currencySymbol) + ' ' }"
                       class="form-control" [ngClass]="{'is-invalid state-invalid': deposito.controls.valor.invalid && isSubmitted}" type="text" name="valorSolicitado"
                        id="txtValorSolicitado" (focusout)="valorChanged()">
                <div class="invalid-feedback">{{valorFeedBack}}</div>
              </div>
            </div>
            <div class="col-xl col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="txtTaxa" class="form-label">{{ 'common.fee' | translate}}</label>
                <input [prefix]="( '' | currencySymbol ) + ' '" [formControl]="deposito.controls.taxa" mask="separator.2" [leadZero]="true" decimalMarker="," thousandSeparator="." class="form-control" type="text" name="taxa" id="txtTaxa" [readonly]="true">
              </div>
            </div>
            <div class="col-xl col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="txtValorTotal" class="form-label">{{ 'common.totalAmount' | translate}}</label>
                <input [prefix]="( '' | currencySymbol ) + ' '" [formControl]="deposito.controls.valorTotal" mask="separator.2" [leadZero]="true" decimalMarker="," thousandSeparator="." class="form-control" type="text" name="valorTotal" id="txtValorTotal" [readonly]="true">
              </div>
            </div>
            <div class="col-xl col-lg-6 col-sm-6">
              <button type="button" class="our-button btn btn-pill btn-primary" (click)="makeDeposit()"><i class="fe fe-arrow-down-right"></i>{{ 'common.depositButton' | translate}}</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<div class="row" *ngIf="pixGenerated">
  <div class="col-12">
    <div class="card sales-summary rounded-10 shadow">
      <div class="card-header">
        <div class="card-title mb-0">{{ 'common.paymentInformation' | translate}}</div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-xl-3 col-lg-6 col-sm-6 text-center">
            <h5 class="text-center">{{ 'common.qrCode' | translate}}</h5>
            <img [src]="qrCodeBase64" alt="Qr Code" />
          </div>
          <div class="col-xl-9 col-lg-6 col-sm-6 text-center">
            <h5 class="text-center">{{ 'common.copyPastePix' | translate}}</h5>
            <textarea class="form-control" [ngModel]="pixCopiaECola" disabled></textarea>
            <button class="btn btn-primary" placement="top" ngbPopover="Copiado!" [cdkCopyToClipboard]="pixCopiaECola">{{ 'common.copyButton' | translate}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
